import { useMemo } from 'react';
import { removeNullAndUndefined } from '@deephaven/utils';
export function useFilterConditionFactories(maybeTable) {
  for (var _len = arguments.length, filterConditionFactories = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filterConditionFactories[_key - 1] = arguments[_key];
  }
  return useMemo(() => removeNullAndUndefined(...filterConditionFactories.map(f => f(maybeTable))),
  // Intentionally disabling hooks check so we can spread
  // the array items as dependencies.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [maybeTable, ...filterConditionFactories]);
}
export default useFilterConditionFactories;
//# sourceMappingURL=useFilterConditionFactories.js.map